import type { MeasurementReviewField } from "./measurement-review";

const otherElement = /\b(?:windows?|doors?|openings?|rooflights?|lanterns?|parapets?|sills?|lintels?)\b/i;
const wallHeight = /\b(?:walls?\s+(?:overall\s+)?height|height\s+of\s+(?:the\s+)?(?:(?:external|extension)\s+)?walls?|extension\s+(?:overall\s+)?height)\b/i;

/** A location ("rear extension") does not identify the object being measured. */
export function isWallHeightMeasurement(field: MeasurementReviewField) {
  if (field.unit !== "m") return false;
  // A previously compacted heading must not override the original source label.
  const label = field.original?.label || field.label;
  if (otherElement.test(label)) return false;
  const note = field.original?.note || field.note;
  if (!/\bwalls?\b/i.test(label) && otherElement.test(note)) return false;
  if (wallHeight.test(label)) return true;
  return !otherElement.test(note) && wallHeight.test(note);
}
